import React, { useState } from "react";
import { useForm } from "react-hook-form";

// components
import List from "./DataView/List";
import ModalWhiteList from "./Modal/ModalWhiteList";

const WhiteListIA = ({
  visible,
  setVisible,
  loading,
  setLoading,
  handleAdd,
}) => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);

  const { control, watch } = useForm({
    defaultValues: {
      pessoa: null,
    },
    mode: "onChange",
  });

  return (
    <form style={{ position: "relative", minHeight: 180, width: "100%" }}>
      <ModalWhiteList
        visible={visible}
        onHide={() => setVisible(false)}
        control={control}
        handleAdd={handleAdd}
        watch={watch}
        loading={loading}
        setLoading={setLoading}
        refetch={() => {
          setFirst(0);
          setRows(5);
        }}
      />
      <div style={{ marginTop: 16, overflowX: "auto", width: "100%" }}>
        <div style={{ minWidth: 350 }}>
          <List
            control={control}
            page={first}
            rows={rows}
            onPageChange={(e) => {
              setFirst(e.first);
              setRows(e.rows);
            }}
          />
        </div>
      </div>
    </form>
  );
};

export default WhiteListIA;
